import { motion } from 'framer-motion';
import { Button, Modal } from '@shared/cove-ui';
import { ComponentProps } from 'react';

export default function QualifiedModal({
  onConfirm,
  ...props
}: Partial<ComponentProps<typeof Modal>> & { onConfirm?: () => void }) {
  return (
    <Modal {...props}>
      <Modal.Content
        noCloseButton
        onPointerDownOutside={(e) => {
          // Disable closing the modal when clicking outside
          e.preventDefault();
        }}
        className="flex w-[calc(100%-30px)] max-w-[720px] flex-col items-center justify-center rounded-none border-2 border-cove-green bg-white px-cove-25 py-cove-35"
      >
        <div>
          <p className="mb-cove-25">You've qualified with Affirm</p>
          <div className="my-[7px] flex h-[2px] w-full max-w-button items-center justify-between rounded-full bg-cove-dove">
            <motion.div
              key="check-1"
              initial={{ scale: 0, x: '-50%', background: '#e4ded6' }}
              animate={{ scale: 1, x: '-50%', background: '#3ebeb0' }}
              transition={{ delay: 0.25, type: 'spring', bounce: 0 }}
              className="flex size-4 items-center justify-center rounded-full border-2 border-cove-green text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 19 19"
                fill="none"
                className=""
              >
                <motion.polyline
                  initial={{ pathLength: 0, opacity: 0 }}
                  animate={{
                    pathLength: 1,
                    opacity: 1,
                  }}
                  transition={{
                    delay: 0.55,
                    type: 'spring',
                    bounce: 0,
                  }}
                  points="3,10 8,15 16,4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </motion.div>
            <motion.div
              key="check-2"
              initial={{ scale: 0, background: '#e4ded6' }}
              animate={{ scale: 1, background: '#3ebeb0' }}
              transition={{ delay: 0.7, type: 'spring', bounce: 0 }}
              className="flex size-4 items-center justify-center rounded-full border-2 border-cove-green text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 19 19"
                fill="none"
                className=""
              >
                <motion.polyline
                  initial={{ pathLength: 0, opacity: 0 }}
                  animate={{
                    pathLength: 1,
                    opacity: 1,
                  }}
                  transition={{
                    delay: 1,
                    type: 'spring',
                    bounce: 0,
                  }}
                  points="3,10 8,15 16,4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </motion.div>
            <motion.div
              key="check-3"
              initial={{ scale: 0, x: '50%' }}
              animate={{ scale: 1, x: '50%' }}
              transition={{ delay: 1.25, type: 'spring', bounce: 0 }}
              className="size-4 rounded-full bg-cove-dove"
            ></motion.div>
          </div>
        </div>
        <Button
          onClick={onConfirm}
          variant="outlined"
          className="mt-cove-25 hover:text-cove-blue"
        >
          Next Step
        </Button>
      </Modal.Content>
    </Modal>
  );
}
